<template>
    <!-- Linke Sidebar (kann für Layer-Ansicht oder Einstellungen genutzt werden) -->
    <div class="sidebar-left">
      <h3>Layer-Ansicht / Einstellungen</h3>
      <!-- Hier könnte später eine zusätzliche Komponente oder Logik eingebaut werden -->
    </div>

    <!-- Hauptbereich mit dem EditorView -->
    <div class="main-content">
      <EditorView @update-style="updateStyle" />
    </div>

    <!-- Rechte Sidebar für CSS-Bearbeitung -->
    <SidebarRight
        :initialMargin="style.margin"
        :initialPadding="style.padding"
        @update-style="updateStyle"
    />
</template>

<script>
import EditorView from './components/EditorView.vue'
import SidebarRight from './components/SidebarRight.vue'

export default {
  name: 'App',
  components: {
    EditorView,
    SidebarRight
  },
  data() {
    return {
      style: {
        margin: 0,
        padding: 0
      }
    }
  },
  methods: {
    updateStyle(styleProp, value) {
      // Aktuelle Werte für CSS-Eigenschaften aktualisieren
      this.style[styleProp] = value;
    }
  }
}
</script>

<style>
#app {
  display: flex;
  height: 100vh;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

/* Linke Sidebar */
.sidebar-left {
  width: 20%;
  padding: 20px;
  background-color: #f8f9fa;
  border-right: 1px solid #ddd;
  overflow-y: auto;
}

/* Hauptinhalt */
.main-content {
  flex-grow: 1;
  padding: 20px;
  overflow-y: auto;
}

/* Rechte Sidebar */
.sidebar-right {
  width: 20%;
  padding: 20px;
  background-color: #f8f9fa;
  border-left: 1px solid #ddd;
  overflow-y: auto;
}
</style>
